import React from 'react';
import TeamComponent from './team.component';

const Team = (props) => {
    return <TeamComponent {...props} />;
};

export default Team;
